// extracted by mini-css-extract-plugin
module.exports = {"mainSectionWrapper":"views-Profile__mainSectionWrapper--1eaSu","loadingIndicator":"views-Profile__loadingIndicator--aCaio"};